module.exports = __webpack_public_path__ + "static/media/newline8.d217a99b.jpg";